import styled from "styled-components";
import { FlexTable } from "@common/components/table/FlexTable";
import { useStore } from "@state/store";
import useSortConfig from "@common/hooks/useSortConfig";
import { useEffect, useRef } from "react";
import { useProjectDataStore } from "@state/projectDataStore";
import Filters from "@common/components/ResidenceGeneric/Filters";
import ResidencePopup from "@common/components/ResidenceGeneric/ResidencePopup";
import { useCanvasStore } from "@state/canvasStore";
import { HeartIcon } from "@radix-ui/react-icons";
import { CAM_POSITION_INDEX, ROUTE_CAM_POSITIONS } from "@data/cameraData";
import { useLocation } from "react-router-dom";
import Popup from "@common/canvas/Popup";

const ResidencesType2 = () => {
  const { residencesData } = useProjectDataStore((s) => ({
    residencesData: s.residencesData,
    availabilityData: s.availabilityData,
    typeData: s.typeData,
    brandingData: s.brandingData,
    setLocalState: s.setLocalState,
  }));
  const { sortConfig, setSortConfig } = useSortConfig();
  const controlsRef = useRef(null);
  const syncState = useStore((s) => s.syncState);
  const selectedUnit = useStore((s) => s.selectedUnit);
  const filteredUnits = useStore((s) => s.filteredUnits);
  const residencePopup = useStore((s) => s.residencePopup);

  const { pathname } = useLocation();
  const setCameraData = useCanvasStore((s) => s.setCameraData);

  useEffect(() => {
    setTimeout(() => {
      syncState({ controlsVisible: true });
    }, 300);

    return () => {
      syncState({
        controlsVisible: false,
      });
    };
  }, []);

  useEffect(() => {
    setCameraData(ROUTE_CAM_POSITIONS[pathname] || CAM_POSITION_INDEX.corner);
  }, [pathname]);

  const categories = residencesData?.categories;

  useEffect(() => {
    syncState({
      contentControls: {
        categories: categories,
        index: 0,
      },
    });

    return () => {
      syncState({
        selectedUnit: null,
        residencePopup: false,
        contentControls: null,
      });
    };
  }, []);

  const headers = [
    "Unit",
    "price",
    "floor",
    "beds",
    <HeartIcon className="fav-icon" />,
  ];

  const cells = ["id", "price", "floor", "beds"];

  return (
    <Wrapper>
      {/* <Popup active={selectedUnit?.[0]} /> */}
      <ControlsWrapper ref={controlsRef} controlsVisible={true}>
        <FilterContainer>
          <Filters className="filters" />
        </FilterContainer>
        <TableContainer>
          <FlexTable
            className="table"
            uniqueKey="unitName"
            headers={headers}
            selection="single"
            cells={cells}
            data={filteredUnits?.filter((unit) => unit.active) || []}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            onSelectionChange={(rows) => {
              syncState({
                selectedUnit: rows,
              });
            }}
          />
        </TableContainer>
      </ControlsWrapper>
      {selectedUnit?.length != 0 && selectedUnit != null && (
        <div
          style={{
            visibility: residencePopup ? "hidden" : "visible",
          }}
          className="viewButton"
          onClick={() => {
            if (residencePopup) {
              syncState({ residencePopup: false, categoriesVisible: false });
            } else syncState({ residencePopup: true, categoriesVisible: true });
          }}
        >
          <div>View Unit</div>
        </div>
      )}
      <ResidencePopup selectedUnit={selectedUnit} />
    </Wrapper>
  );
};

export default ResidencesType2;

const ControlsWrapper = styled.div<{ controlsVisible: boolean }>`
  background-color: var(--primary);
  border-left: 2px solid #2c2528;
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  pointer-events: all;
  flex-direction: column;
  padding: 2rem;
  gap: 2rem;
  justify-content: center;
  align-items: center;

  .toggleIcon {
    top: 2rem;
    position: absolute;
    right: 0;
    z-index: 2;
    border-radius: 0 100% 100% 0;

    img {
      filter: invert(100%);
      transform: ${(props) => (!props.controlsVisible ? "rotate(180deg)" : "")};
      transition: 0.3s ease-in-out;
    }
  }

  .visible {
    transform: rotate(180deg);
    transition: 0.3s;
  }
`;

const Wrapper = styled.div`
  z-index: 5;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  display: flex;

  .viewButton {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: var(--secondary);
    margin: 1.75rem 4.5rem;
    padding: 1.5rem 4rem;
    border-radius: 5px;
    border: 1px solid var(--primary);
    color: white;
    cursor: pointer;
    pointer-events: all;
    z-index: 20000;
  }
`;

const FilterContainer = styled.div`
  width: 100%;
  flex-shrink: 1;
  border-radius: 5px;
  background-color: #ffffff50;
`;

const TableContainer = styled.div`
  width: 100%;
  flex: 1;
  height: 0;
`;
